import styled from 'styled-components';
import { getFontSize } from '../utils/getFont';

const CheckboxContainer = styled.div`
  display: block;
  background-color: var(--background-alt);
  border-radius: 6px;
  border: ${({ bordered }) => (bordered ? '2px solid var(--text)' : 'none')};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop}px;` : '')}

  label {
    user-select: none;
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    color: var(--text);
    ${({ fontSize }) => getFontSize(fontSize)}

    input[type='checkbox'] {
      margin-right: 8px;
      accent-color: var(--primary);
      cursor: pointer;
      transform: scale(1.25);
    }

    &:hover {
      background-color: var(--background-hover);
    }
  }
`;

export const Checkbox = ({
  className,
  label,
  checked = false,
  onChange,
  fontSize = 4,
  maxWidth = '100%',
  bordered,
  marginTop = 0,
}) => {
  const handleChange = (e) => {
    if (onChange) onChange(e.target.checked);
  };

  return (
    <CheckboxContainer
      className={className}
      bordered={bordered}
      fontSize={fontSize}
      marginTop={marginTop}
      maxWidth={maxWidth}
    >
      <label>
        <input type="checkbox" checked={checked} onChange={handleChange} />
        {label}
      </label>
    </CheckboxContainer>
  );
};
